import styled, { css } from 'styled-components';

// The inset the button keeps from the right edge of the control it clears, and
// the width of its box (the 16rem icon inside MUI's ripple). Together they are
// the column the button occupies: a control that cannot let its own contents
// sit under the button - the colour swatch, the table's rows - pads itself by
// CLEAR_BUTTON_GUTTER so they stop short of that column, the way a radio
// group's options do by ending before the inline button.
export const CLEAR_BUTTON_INSET = 10;
export const CLEAR_BUTTON_BOX = 26;
// Plus the same breathing room the inline button keeps from the last option.
export const CLEAR_BUTTON_GUTTER = CLEAR_BUTTON_INSET + CLEAR_BUTTON_BOX + 16;

interface StyledProps {
  right: string;
  controlHeight?: string;
  alignTop?: boolean;
  alignCenter?: boolean;
  isHidden?: boolean;
}

// Kept out of the layout but still occupying its space, so a control does not
// shift sideways the moment the question gains a value and the button appears.
const hiddenStyles = css`
  visibility: hidden;
  pointer-events: none;
`;

export const AbsoluteClearWrapper = styled.div`
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  right: ${(props: StyledProps) => props.right};

  ${(props: StyledProps) => {
    if (props.alignTop) {
      return css`
        top: 10rem;
      `;
    }
    if (props.alignCenter) {
      // Controls whose height comes from their content - the colour swatch,
      // the table's rows - centre the button on the control itself.
      return css`
        top: 0;
        bottom: 0;
      `;
    }
    // Centre on the control itself rather than on the wrapper, which can
    // also hold an error message underneath the field.
    return css`
      top: 0;
      height: ${props.controlHeight};
    `;
  }};

  ${(props: StyledProps) => props.isHidden && hiddenStyles};
`;

export const InlineClearWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  margin-left: 16rem;
  // Same inset the pinned button uses, so an inline button lands on the same
  // line as the clear buttons of the fields above and below it.
  margin-right: ${(props: StyledProps) => props.right};

  ${(props: StyledProps) => props.isHidden && hiddenStyles};
`;
